export default "__VITE_ASSET__BNpvknrg__"